// @ts-nocheck
// Agent Portal (/cti2) — Dialer's Recent Calls list, split out of
// Dialer.tsx. Pure presentation; the row shape (useRecentCalls) and the
// shared per-customer remark lookup (getRemarkForCall) are computed by the
// parent and passed in.
import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import { FaUser, FaUserSlash } from 'react-icons/fa';
import { toast } from 'sonner';
import { maskNumber } from '@/utilities/cliDisplay';
import { callOutcomeEvt } from '@/features/cti/ctiHelpers';

const RECENT_CALLS_LIMIT = 60;

export default function DialerRecentCalls({
  recentCalls,
  maskNumbers,
  getRemarkForCall,
  onPickNumber,
}) {
  return (
    <div className="ctiv3-recent flex min-h-0 flex-1 flex-col px-1 pb-1">
      <div className="ctiv3-recent__head shrink-0">
        <span className="ctiv3-recent__label">Recent Calls</span>
        <span className="ctiv3-recent__count">{recentCalls.length}</span>
      </div>
      <div className="ctiv3-recent__list min-h-0 flex-1">
        {recentCalls.length === 0 ? (
          <div className="ctiv3-recent__empty">No recent calls</div>
        ) : (
          <>
            {recentCalls.slice(0, RECENT_CALLS_LIMIT).map((item) => {
              const remark = (getRemarkForCall?.(item)) || item.fallbackRemark;
              return (
                <button
                  key={item.id}
                  type="button"
                  className="ctiv3-recent__row"
                  title={item.num ? `Fill ${maskNumbers ? maskNumber(item.num) : item.num}` : undefined}
                  onClick={() => {
                    if (item.dialNum) onPickNumber(item.dialNum);
                    else if (item.num && item.num !== 'Unknown') toast.error('This number is masked and can’t be redialed.');
                  }}
                >
                  <span
                    className="ctiv3-recent__avatar"
                    aria-hidden
                    title={item.isSavedContact ? 'Saved contact' : 'Not in your contacts'}
                  >
                    {item.isSavedContact ? (
                      <FaUser size={16} />
                    ) : (
                      <FaUserSlash size={14} className="text-muted-foreground" />
                    )}
                  </span>
                  <span className="ctiv3-recent__body">
                    <span className="ctiv3-recent__name">
                      <span className={`ctiv3-recent__dir-icon ${item.colorClass}`}>{item.icon}</span>
                      {item.name}
                    </span>
                    {item.num && item.num !== 'Unknown' && (
                      <span className="ctiv3-recent__meta tabular-nums">
                        {maskNumbers ? maskNumber(item.num) : item.num}
                      </span>
                    )}
                    <span className="ctiv3-recent__meta">
                      {item.time}
                      {item.dur && !item.unanswered ? ` · ${item.dur}` : ''}
                      {item.dur && item.unanswered ? (
                        <span className={`call-evt call-evt--static call-evt--${callOutcomeEvt(item.dur)} ml-1.5`}>{item.dur}</span>
                      ) : null}
                    </span>
                    {item.typeBadges?.length > 0 && (
                      <span className="mt-1 flex flex-wrap gap-1">
                        {item.typeBadges.map((b) => (
                          <span
                            key={b.label}
                            className="rounded-full border px-1.5 py-0.5 text-[9px] font-semibold leading-none"
                            style={{ background: b.bg, color: b.color, borderColor: b.border }}
                          >
                            {b.label}
                          </span>
                        ))}
                      </span>
                    )}
                    {remark && (
                      <span
                        className="mt-1 inline-flex max-w-full items-center gap-1 rounded-full bg-muted px-1.5 py-0.5 text-[9px] font-medium text-muted-foreground"
                        title={remark}
                      >
                        <FiMessageSquare size={9} className="shrink-0" />
                        <span className="truncate">{remark}</span>
                      </span>
                    )}
                  </span>
                </button>
              );
            })}
            {recentCalls.length > RECENT_CALLS_LIMIT && (
              <div className="flex items-center gap-2 py-3 text-[10px] uppercase tracking-wide text-muted-foreground/70 before:h-px before:flex-1 before:bg-border after:h-px after:flex-1 after:bg-border">
                Showing your most recent {RECENT_CALLS_LIMIT} calls
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
